<template>
  <div id="product" class="bg-silver section-container p-t-20">
    <div class="container">
      <!-- <ol class="breadcrumb m-b-10 f-s-12">
        <li class="breadcrumb-item">
          <router-link :to="{ name: 'Home'}">Home</router-link>
        </li>
        <li class="breadcrumb-item" v-if="purchase && purchase.product">
          <router-link :to="{ name: 'Product', params: { slug: purchase.product.slug }}">{{ purchase.product.name }}</router-link>
        </li>
      </ol> -->
      <div v-if="purchase" class="checkout">
        <div class="checkout-body">
          <!-- BEGIN checkout-message -->
          <div class="checkout-message">
            <h1>Well Done! <small>You can download the App by using the link below</small></h1>
            <div class="table-responsive2">
              <table class="table table-payment-summary">
                <tbody>
                  <tr>
                    <td class="field">Name</td>
                    <td class="value">{{ purchase.product.name }}</td>
                  </tr>
                  <tr>
                    <td class="field">Transaction Status</td>
                    <td class="value">Success</td>
                  </tr>
                  <tr>
                    <td class="field">Payment Amount</td>
                    <td class="value">Free</td>
                  </tr>
                  <tr>
                    <td class="field">Download</td>
                    <td class="value"><a class="btn-link" :href="`${baseUrl}/purchase/${purchase._id}/download?authToken=${authToken}`">Download this App</a></td>
                  </tr>                  
                </tbody>
              </table>
            </div>
            <p class="text-muted text-center m-b-0">Install the App by clicking twice on the downloaded file.</p>
          
          </div>
          <!-- END checkout-message -->
           <!-- and Run it through "{{ purchase.product.viewer }}" platform -->
          <a class="btn btn-lg btn-womia" style="margin: auto; display: table;" href="/beta/profile/purchase">My purchases</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vuex from 'vuex'
import Vue from 'vue'

export default {
  name: 'Install',
  data() {
    return {
      purchase: null,
      baseUrl: Vue.http.options.root
    }
  },
  components: {},
  computed: {
    ...Vuex.mapGetters(['authToken'])
  },
  created: function () {
    this.fetchData()
  },
  methods: {
    fetchData: function () {
      this.$http
        .get(`purchase/${this.$route.params.id}`, {
          params: { populate: 'product' }
        })
        .then(
          response => {
            this.purchase = response.data
          },
          error => {
            // error callback
            console.log(error)
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/public/Install.vue